import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import LoginForm from '../Components/LoginForm.js';
import AuthenticationService from '../Services/AuthenticationService.js';
import UserService from '../Services/UserService.js';
import { withApi } from '../Providers/WebServiceProvider.js';

import logo from '../assets/images/tovertaal_logo@2x.png';

class Login extends Component
{
	constructor(props) {
		super(props);

		this.loginSubmit   = this.loginSubmit.bind(this);
		this.authService  = new AuthenticationService(props.webServiceContext.getApi());
		this.userService  = new UserService(props.webServiceContext.getApi());         
	}

	loginSubmit = (username, password) => {
		const that = this;

		return new Promise((resolve, reject) => {
			that.authService.login(username, password)
				.then(function (tokenDetails) {
					that.props.webServiceContext.auth.setAccessToken(tokenDetails.access_token);
					that.userService.me().then(function (response) {
						that.props.webServiceContext.auth.setUser(response.user);
						resolve();
					}).catch(function () {
						reject();
					})
				})
				.catch(function (response) {
					const data = response.response.data;
					if (data.errors) {
						reject(data.errors);
					} else if (response.response.status === 401) {
						reject({ credentials: "Email or password is invalid." });
					}
				});
    });
	}

	render () {
		return (
			<div className="container">
				<div className="columns">
					<div className="column"></div>
					<div className="column">
						<section className="section">
              <NavLink exact className="is-flex tovertaal-logo" style={{justifyContent: 'center' }} to="/">
	              <figure className="image" style={{ width: 140, height: 55 }}>
	                <img src={logo} alt="Tovertaal: Localisation System" width="140" height="55" />
	             	</figure>
              </NavLink>
						</section>
						<LoginForm onSubmit={this.loginSubmit} />
            <NavLink exact className="is-flex" style={{justifyContent: 'center', marginTop: '10px'}} to="/reset-password">
              <p>Forgot password?</p>
            </NavLink>
					</div>
					<div className="column"></div>
				</div>
			</div>
		);
	}
}

export default withApi(Login);


// WEBPACK FOOTER //
// ./src/Pages/Login.js